module.exports = __webpack_public_path__ + "d4c0b303/img/document.e2130c6b.svg";